import { Paragraph } from "@unlikelyai-magic/ui/typography";
import { cn } from "@unlikelyai-magic/utils";

export interface ConfigurationData {
  title: string;
  statements: string[];
}

interface ConfigurationViewProps {
  configuration: ConfigurationData;
  className?: string;
}

export const ConfigurationView = ({
  configuration,
  className,
}: ConfigurationViewProps) => {
  return (
    <div className={cn("flex flex-col", className)}>
      <div className="px-6 py-4 space-y-3 bg-slate-100 overflow-y-auto max-h-96">
        {configuration.statements.map((statement, index) => (
          <Paragraph key={index} className="text-sm leading-relaxed">
            {statement}
          </Paragraph>
        ))}
      </div>
      <div className="px-6 py-4 border-t border-gray-200 bg-gray-50">
        <Paragraph className="text-sm text-slate-500 font-inter">
          Configurations cannot be changed. Contact support to get help.
        </Paragraph>
      </div>
    </div>
  );
};
